<ng-container *ngIf="email">
    <!--     <tt-card [ttHeading]="archiveHeading" ttTranslate="false"> 

        <h3 class="w_email-archive-form__heading">{{ archiveHeading }}</h3>
        <hr style="width: 100%" /> -->

    <tt-input ttLabel="cust_no" [ttModel]="email.cust_no" ttReadonly [ttButtons]="email.cust_no > '0' ? customerButtons : []">
        <ng-container buttons>
            <ng-container *ngIf="email.cust_no == 0">
                <tt-form-field-button *ngIf="!('mobile' | mediaQuery)" ttId="create" ttType="primary" ttIcon="fas fa-plus" (ttClick)="openCustomerEditPopup()"></tt-form-field-button>
                <tt-form-field-button *ngIf="'mobile' | mediaQuery" ttId="create" ttType="primary" ttIcon="fas fa-plus" ttGoto="customeredit" [ttGotoParms]="{ cust_no: '0' }"></tt-form-field-button>
            </ng-container>
        </ng-container>
    </tt-input>
    <tt-search ttLabel="cust_name" [(ttModel)]="email.cust_name" [ttSearch]="searchCustomer" (ttOnSelected)="onCustomerSelected($event)" (ttOnClear)="onCustomerSelected()"></tt-search>

    <tt-search
        ttLabel="project_search"
        [(ttModel)]="email.project_name"
        [ttSearch]="searchProjects"
        ttMinLength="0"
        (ttOnSelected)="onProjectSelected($event)"
        (ttOnClear)="onProjectSelected()"
        [ttButtons]="email.project_keyno > '0' ? projectButtons : emptyProjectButtons"
    ></tt-search>

    <tt-search
        [hidden]="email.project_keyno == '0'"
        ttLabel="projectprosess_keyno_search"
        ttMinLength="0"
        [(ttModel)]="email.prosess_name"
        [ttData]="projectProcesses"
        ttDataId="projectprosess_keyno"
        ttDataName="projectprosess_name"
        (ttOnSelected)="onProcessSelected($event)"
    ></tt-search>

    <tt-checkbox ttLabel="email_create_new_custact" [(ttModel)]="email.create_new_custact"></tt-checkbox>

    <tt-search
        *ngIf="email.create_new_custact == '0'"
        ttLabel="custact_note_search"
        [(ttModel)]="email.custact_note"
        ttMinLength="0"
        [ttSearch]="searchCustacts"
        (ttOnSelected)="onCustactSelected($event)"
        (ttOnClear)="onCustactSelected()"
        [ttButtons]="email.custact_no > '0' ? custactButtons : []"
    ></tt-search>

    <tt-select
        [hidden]="email.create_new_custact == '0'"
        ttRememberId="w_email.activitytype_no"
        ttLabel="activitytype"
        [(ttModel)]="email.activitytype_no"
        [ttData]="activityTypes"
        ttDataId="activitytype_no"
        ttDataName="activitytype_name"
    ></tt-select>
    <tt-textarea [hidden]="email.create_new_custact == '0'" ttLabel="custact_note" [(ttModel)]="email.custact_note_new"></tt-textarea>
    <tt-select [hidden]="email.create_new_custact == '0'" ttLabel="portal_user_keyno_responsible" [(ttModel)]="email.portal_user_keyno_responsible" [ttData]="custactMembers"></tt-select>
    <!-- <tt-input [hidden]="email.create_new_custact == '0'" ttLabel="participant_pu_keynos" [(ttModel)]="email.participant_pu_keynos" ttReadonly></tt-input> -->
    <tt-input [hidden]="email.create_new_custact == '0'" ttLabel="participant_pu_names" [(ttModel)]="email.participant_pu_names" ttReadonly>
        <ng-container buttons>
            <tt-form-field-button ttId="select" ttIcon="far fa-bars" [ttPopover]="selectParticipants"></tt-form-field-button>
        </ng-container>
    </tt-input>

    <tt-search
        ttLabel="order_search_info"
        [(ttModel)]="email.order_search_info"
        ttMinLength="0"
        [ttSearch]="searchOrders"
        (ttOnSelected)="onOrderSelected($event)"
        (ttOnClear)="onOrderSelected()"
        [ttButtons]="email.order_internal_no > '0' ? orderFormButton : []"
    ></tt-search>

    <tt-search
        ttLabel="purch_search_info"
        [(ttModel)]="email.purch_search_info"
        ttMinLength="0"
        [ttSearch]="searchPurchases"
        (ttOnSelected)="onPurchaseSelected($event)"
        (ttOnClear)="onPurchaseSelected()"
        [ttButtons]="email.purch_internal_no > '0' ? purchaseFormButton : []"
    ></tt-search>

    <tt-select *ngIf="companies.length > 1" ttLabel="businessco" [(ttModel)]="email.businessco_no" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
    <tt-button-save [ttText]="email.create_new_custact == '0' ? 'email_archieve' : 'email_create_custact'" (ttClick)="archiveEmail($event)" [ttLoading]="saving" [ttDisabled]="saving"></tt-button-save>
    <tt-button-multi
        [ttText]="email.create_new_custact == '0' ? 'email_archieve_reply' : 'email_create_custact_reply'"
        ttIcon="fas fa-reply"
        (ttClick)="this.archiveEmail($event, { goto_reply: '1' })"
        ttType="success"
        [ttLoading]="saving"
        [ttDisabled]="saving"
    >
        <tt-button
            ttIcon="fas fa-reply-all"
            ttType="success"
            [ttLoading]="saving"
            [ttDisabled]="saving"
            [ttTooltipText]="email.create_new_custact == '0' ? 'email_archieve_reply_all' : 'email_create_custact_reply_all'"
            (ttClick)="archiveEmail($event, { goto_reply: '1', reply_all: '1' })"
        ></tt-button>
    </tt-button-multi>
    <tt-button *ngIf="showCreateVoucher" ttText="w_email_create_voucher" ttIcon="fas fa-arrow-to-bottom" (ttClick)="email.create_voucher = '1'; archiveEmail($event)" [ttLoading]="saving" [ttDisabled]="saving"></tt-button>
    <tt-button ttText="email_create_offer" ttIcon="fas fa-arrow-to-bottom" (ttClick)="email.create_offer = '1'; archiveEmail($event)" [ttLoading]="saving" [ttDisabled]="saving"></tt-button>
    <!-- <tt-button-goto ttText="w_email_create_customers" ttGoto="customeredit" ttGotoParms="0"></tt-button-goto> -->
    <!-- </tt-card> -->

    <!-- <tt-card ttHeading="w_email_personinfo"> -->
    <!-- <hr style="width: 100%" /> -->

    <!-- <tt-input ttLabel="recipient_name" [ttModel]="email.recipient_name" ttReadonly></tt-input> -->
    <!-- <tt-input ttLabel="from_cust_no" [ttModel]="email.from_cust_no" ttReadonly [ttButtons]="email.from_cust_no > '0' ? fromCustomerFormButtons : fromCustomerEmptyFormButtons"></tt-input>
        <tt-search
            ttLabel="from_cust_name"
            [(ttModel)]="email.from_cust_name"
            [ttSearch]="searchFromCustomer"
            (ttOnSelected)="onFromCustomerSelected($event)"
            (ttOnClear)="onFromCustomerSelected()"
        ></tt-search> -->
    <!--<tt-input ttLabel="pers_no" [ttModel]="email.pers_no" ttReadonly></tt-input>-->
    <!-- <tt-select ttLabel="from_pers_name" [(ttModel)]="email.pers_no" [ttData]="fromPersons" ttShowClearButton></tt-select>

        <ng-container *ngIf="email.pers_no == '0'">
            <tt-input ttLabel="sender_name_new" [(ttModel)]="email.sender_name_new"></tt-input>
        </ng-container>
        <tt-input ttLabel="sender_email_new" [(ttModel)]="email.sender_email_new"></tt-input>

        <tt-button-save ttText="email_fromperson_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</ng-container> -->
</ng-container>
<tt-grid *ngIf="!!grid" [(ttOptions)]="grid" (ttReady)="onGridReady()"></tt-grid>

<ng-template #selectParticipants>
    <div style="width: min(95vw, 40rem); height: min(95vh, 50rem); overflow: auto">
        <tt-multi-select [(ttData)]="portalUsers" (ttDataChange)="onParticipantSelected()" ttDataId="portal_user_keyno" ttDataName="user_name"> </tt-multi-select>
    </div>
</ng-template>
